import {
  Box,
  Button,
  CardContent,
  Dialog,
  List,
  ListItemButton,
  Menu,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import { MenuIcon } from "../icons";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ngDataState, autoFillDataState, ngCountState } from "../recoil";
import { useTranslation } from "react-i18next";
import { SelectTrain } from "./project/ProjectModal";
import { getProjectNG } from "../services/projectService";
import { IAddProject, IImageInfo, ITrainData } from "@types";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { t } from "i18next";
import { useTrainHandler } from "../hooks/useTrainHandler";

interface MenuButtonProps {
  step: string;
  className?: string;
}

const sseUrl = "/sse";
let ai_server = "";

export default function MenuButton({ step, className }: MenuButtonProps) {
  const { id, label } = useParams();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const [trainOption, setTrainOption] = useState<ITrainData | null>(null);
  // const [openSelectTrain, setOpenSelectTrain] = useState<boolean>(false);
  const [autoFillData, setAutoFillData] = useRecoilState(autoFillDataState);
  const [projectData, setProjectData] = useState<IAddProject>({
    project_name: "",
    step: "분류",
    material_name: "",
    images: [],
    train_id: null,
  });
  // const [isTraining, setIsTraining] = useState<boolean>(false);
  const [ngData, setNgData] = useRecoilState(ngDataState);
  const ngCount = useRecoilValue(ngCountState);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
    setMenuOpen((prev) => !prev);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const {
    handleTrain,
    handleTrainChange,
    handleSelectTrain,
    trainOption,
    openSelectTrain,
    setOpenSelectTrain,
  } = useTrainHandler({
    id,
    step,
    label,
    projectDataStep: projectData.step,
    t,
    // isTraining,
    // setIsTraining,
    isTrainable: ngCount > 10,
  });

  const handleGotoNewProject = async () => {
    if (!id) return;
    try {
      const response = await getProjectNG(Number(id));

      if (response.ngData[0].projectImageLabel.length >= 10) {
        setNgData(response.ngData);
        setAutoFillData(response.ngData);
        navigate("/projects/create", { state: { initStep: "분석" } });
      } else {
        toast.warning("NG 데이터가 10개 이상인 경우에 분석 실행이 가능합니다.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleNavigate = (path: string) => {
    navigate(`/project/${id}/${path}`);
  };

  return (
    <>
      <Button
        variant="outlined"
        sx={{
          borderColor: "var(--icon-color)",
          height: "30px",
          fontSize: "13px",
          size: "small",
          gap: 1,
          minWidth: "36px",
          "&:hover": {
            borderColor: "var(--header-hover-bg)",
            background: "var(--header-hover-bg)",
          },
        }}
        onClick={handleMenuOpen}
      >
        <MenuIcon sx={{ color: "var(--icon-color)" }} />
      </Button>
      {menuOpen && (
        <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleClose}>
          {step === "분류" ? (
            <MenuItem
              onClick={() => {
                handleTrain();
                setMenuOpen(false);
              }}
            >
              {t("Train")}
            </MenuItem>
          ) : label ? (
            <MenuItem
              onClick={() => {
                handleTrain();
                setMenuOpen(false);
              }}
            >
              {t("PersonalModel")} {t("Train")}
            </MenuItem>
          ) : (
            <MenuItem
              onClick={() => {
                handleTrain();
                // testTrain(step);
                setMenuOpen(false);
              }}
            >
              {t("IntegratedModel")} {t("Train")}
            </MenuItem>
          )}
          {step === "분류" && (
            <MenuItem
              onClick={() => {
                handleGotoNewProject();
                setMenuOpen(false);
              }}
            >
              {t("Analysis")}
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              handleNavigate("history");
              setMenuOpen(false);
            }}
          >
            {t("History")}
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleNavigate("report");
              setMenuOpen(false);
            }}
          >
            {t("Report")}
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleNavigate("setting");
              setMenuOpen(false);
            }}
          >
            {t("Setting")}
          </MenuItem>
        </Menu>
      )}
      {openSelectTrain && (
        <Dialog open={openSelectTrain} onClose={handleClose}>
          <Paper
            sx={{
              width: "600px",
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                gap: "20px",
                p: "20px",
              }}
            >
              <SelectTrain
                selectedTrain={null}
                onTrainChange={handleTrainChange}
              />
            </CardContent>
            <Button onClick={handleSelectTrain}>{t("Edit")}</Button>
            <Button onClick={() => setOpenSelectTrain(false)}>
              {t("Close")}
            </Button>
          </Paper>
        </Dialog>
      )}
    </>
  );
}
